import { ChangeDetectorRef, ElementRef, EventEmitter, Renderer2, inject, } from "@angular/core";
import { ButtonColor, ButtonSize } from "@topyourthree/ui/button";
import { IconColor, IconSize } from "@topyourthree/ui/icon";
import { StickyBehaviour } from "@topyourthree/ui/sticky";
import { ViewHeaderType } from "@topyourthree/ui/view-header";
import { CalloutColor } from "./callout-color";
import * as i0 from "@angular/core";
import * as i1 from "../../directives/hide/hide.directive";
import * as i2 from "../../directives/outside-click/outside-click.directive";
import * as i3 from "../sticky/sticky.directive";
import * as i4 from "../container/container.component";
import * as i5 from "../view-header/view-header.component";
import * as i6 from "../icon/icon.component";
import * as i7 from "../button/button.component";
import * as i8 from "@angular/common";
const _c0 = ["calloutBody"];
const _c1 = ["calloutArrow"];
const _c2 = ["*"];
const _c3 = a0 => ({ zIndex: a0 });
function CalloutContentComponent_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tyt-icon", 9);
    i0.ɵɵlistener("click", function CalloutContentComponent_Conditional_4_Template_tyt_icon_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.handleCloseButtonClick()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", "ui-close")("color", ctx_r2.color === ctx_r2.CalloutColor.LIGHT ? ctx_r2.IconColor.FOREGROUND : ctx_r2.IconColor.LIGHT)("size", ctx_r2.IconSize.SMALL)("hoverAnimation", "spin-and-fade");
} }
function CalloutContentComponent_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 10)(2, "fl-view-header", 11);
    i0.ɵɵlistener("close", function CalloutContentComponent_Conditional_5_Template_fl_view_header_close_2_listener() { i0.ɵɵrestoreView(_r4); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.handleCloseButtonClick()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "fl-container");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("flShowMobile", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("flSticky", true)("flStickyStatic", true)("flStickyBehaviour", ctx_r2.StickyBehaviour.ALWAYS);
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r2.ViewHeaderType.CLOSE)("heading", ctx_r2.mobileHeaderTitle);
} }
function CalloutContentComponent_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "tyt-button", 12);
    i0.ɵɵlistener("click", function CalloutContentComponent_Conditional_8_Template_tyt_button_click_1_listener() { i0.ɵɵrestoreView(_r5); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.handleCloseButtonClick()); });
    i0.ɵɵi18n(2, 2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("flShowMobile", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("color", ctx_r2.ButtonColor.DEFAULT)("size", ctx_r2.ButtonSize.SMALL);
} }
// TODO: T267853 - Need animations for fade-in-out.
// Ref: TODO
export class CalloutContentComponent {
    constructor() {
        this.ButtonColor = ButtonColor;
        this.ButtonSize = ButtonSize;
        this.CalloutColor = CalloutColor;
        this.IconColor = IconColor;
        this.IconSize = IconSize;
        this.StickyBehaviour = StickyBehaviour;
        this.ViewHeaderType = ViewHeaderType;
        this.bodyClick = new EventEmitter();
        this.bodyMouseenter = new EventEmitter();
        this.bodyMouseleave = new EventEmitter();
        this.close = new EventEmitter();
        this.outsideClick = new EventEmitter();
        this.changeDetectorRef = inject(ChangeDetectorRef);
        this.renderer = inject(Renderer2);
    }
    handleOutsideClick(event) {
        const clickedTrigger = this.triggerHtmlElement?.contains(event.target);
        if (clickedTrigger) {
            return;
        }
        this.outsideClick.emit();
    }
    getElementBoundingRect() {
        return this.calloutBody.nativeElement.getBoundingClientRect();
    }
    handleCalloutBodyClick() {
        this.bodyClick.emit();
    }
    handleCalloutBodyMouseenter() {
        if (!this.isMobile) {
            this.bodyMouseenter.emit();
        }
    }
    handleCalloutBodyMouseleave() {
        if (!this.isMobile) {
            this.bodyMouseleave.emit();
        }
    }
    handleCloseButtonClick() {
        this.close.emit();
    }
    setOptions(options) {
        this.bigBorderRadius = options.bigBorderRadius;
        this.color = options.color;
        this.edgeToEdge = options.edgeToEdge;
        this.hideArrow = false;
        this.hideCloseButton = false;
        this.hover = options.hover;
        this.overflowContent = options.overflowContent;
        this.mobileCloseButton = false;
        this.mobileFullscreen = false;
        this.mobileHeaderTitle = options.mobileHeaderTitle;
        this.size = options.size;
        this.triggerHtmlElement = options.triggerHtmlElement;
        this.setMobileOptions();
    }
    setPlacement(placement, triggerElement) {
        const { anchor } = placement;
        const position = anchor === "overlayX" ? "overlayY" : "overlayX";
        // convert into an `anchor-relative` string for css parsing
        this.placement = `${placement[anchor]}-${placement[position]}`;
        // super super hacky: we use some small offsets (4px or 8px) to make things look nice
        // any larger offset probably means we're shifting the callout across some amount
        // TODO: T267853 - maybe we can pass this via a `PanelClass` instead?
        this.arrowOffset =
            Math.abs(placement.offsetX ?? 0) > 10
                ? (placement.offsetX ?? 0)
                : Math.abs(placement.offsetY ?? 0) > 10
                    ? (placement.offsetY ?? 0)
                    : 0;
        this.setArrowPosition(placement[anchor], placement[position], triggerElement);
        this.changeDetectorRef.markForCheck();
    }
    setArrowPosition(anchor, position, triggerElement) {
        const { nativeElement } = this.calloutArrow;
        // Perform style cleanup before re-applying a new position
        this.renderer.removeStyle(nativeElement, "left");
        this.renderer.removeStyle(nativeElement, "right");
        this.renderer.removeStyle(nativeElement, "top");
        this.renderer.removeStyle(nativeElement, "bottom");
        // All anchor orientation that has center positioning is
        // handled in callout-content.component.scss
        if (position === "center") {
            return;
        }
        // Dynamically center the arrow depending on
        // the triggerElement's dimension
        const { offsetHeight, offsetWidth } = triggerElement;
        let arrowOrientation = "";
        let arrowPosition = 0;
        if (anchor === "top" || anchor === "bottom") {
            arrowOrientation = position === "start" ? "left" : "right";
            arrowPosition = offsetWidth / 2;
        }
        if (anchor === "start" || anchor === "end") {
            arrowOrientation = position;
            arrowPosition = offsetHeight / 2;
        }
        this.renderer.setStyle(nativeElement, arrowOrientation, `${arrowPosition}px`);
    }
    setMobileOptions() {
        this.isMobile = false;
        this.shouldShowArrow = true;
        this.shouldShowCloseButton = false;
        return;
        this.isMobile =
            window.innerWidth < parseInt("0px" /* TopYourThreeBreakpointValues.TABLET */, 10);
        this.isMobile = false;
        this.shouldShowArrow = !this.hideArrow;
        this.shouldShowCloseButton = !this.hideCloseButton && !this.hover;
        // Mobile overrides to standardize dialog UIs
        if (this.isMobile) {
            this.shouldShowArrow = false;
            this.shouldShowCloseButton =
                this.mobileFullscreen || this.shouldShowCloseButton;
        }
    }
}
CalloutContentComponent.ɵfac = function CalloutContentComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CalloutContentComponent)(); };
CalloutContentComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CalloutContentComponent, selectors: [["fl-callout-content"]], viewQuery: function CalloutContentComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.calloutBody = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.calloutArrow = _t.first);
    } }, hostVars: 2, hostBindings: function CalloutContentComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵattribute("data-color", ctx.color)("data-mobile-fullscreen", ctx.mobileFullscreen);
    } }, outputs: { bodyClick: "bodyClick", bodyMouseenter: "bodyMouseenter", bodyMouseleave: "bodyMouseleave", close: "close", outsideClick: "outsideClick" }, ngContentSelectors: _c2, decls: 9, vars: 18, consts: () => { let i18n_0; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Close callout button
         */
        const MSG_EXTERNAL_7819314041543176992$$__________________USERS_TAROSAMEJIMA_DOCUMENTS_SCRIPT_TOPYOURTHREE02_TYT_DEMO_SRC__TOPYOURTHREE_UI_CALLOUT_CALLOUT_CONTENT_COMPONENT_TS_0 = goog.getMsg("Close");
        i18n_0 = MSG_EXTERNAL_7819314041543176992$$__________________USERS_TAROSAMEJIMA_DOCUMENTS_SCRIPT_TOPYOURTHREE02_TYT_DEMO_SRC__TOPYOURTHREE_UI_CALLOUT_CALLOUT_CONTENT_COMPONENT_TS_0;
    }
    else {
        i18n_0 = $localize `:Close callout button␟f4e529ae5ffd73001d1ff4bbdeeb0a72e342e5c8␟7819314041543176992:Close`;
    } let i18n_1; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Close callout button
         */
        const MSG_EXTERNAL_8333755895091294198$$__________________USERS_TAROSAMEJIMA_DOCUMENTS_SCRIPT_TOPYOURTHREE02_TYT_DEMO_SRC__TOPYOURTHREE_UI_CALLOUT_CALLOUT_CONTENT_COMPONENT_TS_1 = goog.getMsg(" Close ");
        i18n_1 = MSG_EXTERNAL_8333755895091294198$$__________________USERS_TAROSAMEJIMA_DOCUMENTS_SCRIPT_TOPYOURTHREE02_TYT_DEMO_SRC__TOPYOURTHREE_UI_CALLOUT_CALLOUT_CONTENT_COMPONENT_TS_1;
    }
    else {
        i18n_1 = $localize `:Close callout button␟b640769d91bfeee0a75ba1ddfbde1e64880040c3␟8333755895091294198: Close `;
    } return [["calloutBody", ""], ["calloutArrow", ""], i18n_1, ["flOutsideClick", "", 1, "CalloutBody", "WebappCompatWrapper", 3, "click", "mouseenter", "mouseleave", "outsideClick", "ngStyle"], [1, "CalloutArrow"], ["label", i18n_0, 1, "CloseButton", 3, "name", "color", "size", "hoverAnimation"], [3, "flShowMobile"], [1, "CalloutContent"], [1, "WrapperCloseButtonMobile", 3, "flShowMobile"], ["label", i18n_0, 1, "CloseButton", 3, "click", "name", "color", "size", "hoverAnimation"], [1, "CalloutHeader", 3, "flSticky", "flStickyStatic", "flStickyBehaviour"], [3, "close", "type", "heading"], [3, "click", "color", "size"]]; }, template: function CalloutContentComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 3, 0);
        i0.ɵɵlistener("click", function CalloutContentComponent_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.handleCalloutBodyClick()); })("mouseenter", function CalloutContentComponent_Template_div_mouseenter_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.handleCalloutBodyMouseenter()); })("mouseleave", function CalloutContentComponent_Template_div_mouseleave_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.handleCalloutBodyMouseleave()); })("outsideClick", function CalloutContentComponent_Template_div_outsideClick_0_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.handleOutsideClick($event)); });
        i0.ɵɵelement(2, "div", 4, 1);
        i0.ɵɵtemplate(4, CalloutContentComponent_Conditional_4_Template, 1, 4, "tyt-icon", 5)(5, CalloutContentComponent_Conditional_5_Template, 4, 6, "div", 6);
        i0.ɵɵelementStart(6, "div", 7);
        i0.ɵɵprojection(7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, CalloutContentComponent_Conditional_8_Template, 3, 3, "div", 8);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(16, _c3, ctx.zIndex));
        i0.ɵɵattribute("data-big-border-radius", ctx.bigBorderRadius)("data-position", ctx.placement)("data-edge-to-edge", ctx.edgeToEdge)("data-size", ctx.size)("data-color", ctx.color)("data-hide-arrow", !ctx.shouldShowArrow)("data-arrow-offset", ctx.arrowOffset)("data-mobile-fullscreen", ctx.mobileFullscreen)("data-mobile-close-button", ctx.mobileCloseButton)("tabindex", 0);
        i0.ɵɵadvance(4);
        i0.ɵɵconditional(ctx.shouldShowCloseButton ? 4 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.mobileFullscreen ? 5 : -1);
        i0.ɵɵadvance();
        i0.ɵɵclassProp("OverflowContent", ctx.overflowContent);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(!ctx.mobileFullscreen && ctx.mobileCloseButton ? 8 : -1);
    } }, dependencies: [i1.HideDirective, i2.OutsideClickDirective, i3.StickyDirective, i4.ContainerComponent, i5.ViewHeaderComponent, i6.IconComponent, i7.ButtonComponent, i8.NgStyle], styles: [".CalloutBody[_ngcontent-%COMP%]{border-radius:3px;box-shadow:0 0 12px rgba(18,21,27,.1607843137),0 8px 24px rgba(18,21,27,.2);max-width:100%;padding:32px 24px 24px;background-color:var(--mega-menu-bg-color)}.CalloutBody[data-edge-to-edge=true][_ngcontent-%COMP%]{padding:0}.CalloutBody[data-hide-arrow=false][data-position=top-start][_ngcontent-%COMP%]{transform:translateY(8px)}.CalloutBody[data-hide-arrow=false][_ngcontent-%COMP%]   .CalloutArrow[_ngcontent-%COMP%]{position:absolute;width:0;height:0;border:8px solid rgba(0,0,0,0);pointer-events:none}.CalloutBody[data-position^=top][_ngcontent-%COMP%]   .CalloutArrow[_ngcontent-%COMP%]{border-bottom-color:var(--mega-menu-bg-color)}@media(min-width: 860px){.CalloutBody[data-position^=top][_ngcontent-%COMP%]   .CalloutArrow[_ngcontent-%COMP%]{border-bottom-color:#fff}}.CalloutBody[data-hide-arrow=false][data-position=top-start][_ngcontent-%COMP%]   .CalloutArrow[_ngcontent-%COMP%]{bottom:100%;left:var(--arrow-left, 50%);transform:translateX(-8px);transform-origin:8px 8px}.CalloutContent[_ngcontent-%COMP%]{position:relative}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], changeDetection: 0 });
